












































































































import { Component, Prop, Watch } from 'vue-property-decorator'
import QuestionRadio from './QuestionRadio.vue'
import QuestionCheckBox from './QuestionCheckBox.vue'
import QuestionSelect from './QuestionSelect.vue'
import ExamResultQuestionBodyMixin from './ExamResultQuestionBodyMixin'
import { mixins } from 'vue-class-component'

@Component({
  components: {
    QuestionRadio,
    QuestionCheckBox,
    QuestionSelect
  }
})
export default class ExamResultQuestionBodyMobile extends mixins(ExamResultQuestionBodyMixin) {
  public mounted() {
    window.scrollTo(0, 0)
  }
}
